<template>
  <div>
    <h6 class="text-left table-header">
      {{ header | i18n }}
    </h6>
    <Table
      :columns="columns"
      :rows="items"
      :pagination="false"
      :on-row-click="rowClick"
      tableName="oneBaseTable"
    />
  </div>
</template>

<script>
import { CASE_STATUSES } from '../../../../../../../constants';
import Table from '../../common/table';

export default {
  name: 'LatestOrders',
  components: { Table },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
    rowClick: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      statuses: CASE_STATUSES,
      columns: [
        {
          key: 'number',
          field: 'number',
          title: this.$translate('Project Number'),
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.projectInformation && (row.projectInformation.projectNumber || '');
          },
        },
        { key: 'name', field: 'name', title: this.$translate('Name'), align: 'left' },
        {
          key: 'status',
          field: 'status',
          title: this.$translate('status'),
          align: 'left',
          renderBodyCell: ({ row }, h) => {
            return <span class={`badge status-badge badge-${row.statusColor}`}> {this.$translate(row.status)} </span>;
          },
        },
        {
          key: 'leader',
          field: 'leader',
          title: this.$translate('Project leader'),
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.projectInformation && (row.projectInformation.projectLeader.username || '');
          },
        },
        {
          key: 'documentNumber',
          field: 'purchasingOrder.documentNumber',
          title: this.$translate('Document Number'),
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.purchasingOrder && (row.purchasingOrder.documentNumber || '');
          },
        },
        {
          key: 'articleNumber',
          field: 'purchasingOrder.articleNumber',
          title: this.$translate('Article Number'),
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.purchasingOrder && (row.purchasingOrder.articleNumber || '');
          },
        },
        { key: 'updatedAt', field: 'updatedAt', title: this.$translate('Updated'), align: 'left' },
      ],
    };
  },
  methods: {
    getStatusBadgeVariant(status) {
      switch (status) {
        case this.statuses.ACTIVE:
          return 'success';
        case this.statuses.IN_PROGRESS:
          return 'info';
        case this.statuses.FINISHED:
          return 'secondary';
        default:
          return 'secondary';
      }
    },
  },
};
</script>

<style lang="scss">
.case-table {
  tr {
    cursor: pointer;
  }
}

.badge {
  padding: 0.25em 0.4em !important;
}

.table-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 300;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>
